import { CommonHttp } from "@/models/interfaces/http/common.http.request";
import {
    Client,
    ClientInfo,
    ClientRequestData,
    NewContact
} from "@/store/clients";
import { CommonEntityRecord } from "@/models/interfaces/common";


export class PersonApi {
    // Получение всего списка контактов
    static searchPerson(requestModel: ClientRequestData): Promise<Client[]> {
        const http = new CommonHttp()
        return http
            .post(`persons/search/main`, requestModel)
            .then(data => data.data)
    }

    // Переключить статус «главный контакт в проекте»
    static setMainInProjectStatus(projectId: number, personId: number): Promise<any> {
        const http = new CommonHttp()
        return http
            .put(`persons/status/main`, { projectId, personId })
            .then(data => data.data)
    }

    // Создать контакт
    static createContact(contact: NewContact): Promise<Client> {
        const http = new CommonHttp()
        return http
            .post(`persons`, contact)
            .then(data => data.data)
    }

    // Изменить контакт
    static updateContact(contact: NewContact & { PersonId: number }): Promise<Client> {
        const http = new CommonHttp()
        return http
            .put(`persons`, contact)
            .then(data => data.data)
    }

    // Удаленик контакта
    static deleteContact(personId: number): void {
        const http = new CommonHttp()
        http
            .delete(`persons/${personId}`)
            .then(data => data.data)
    }

    // Получение информации о контакте
    static getClientInfo(personId: number): Promise<ClientInfo> {
        const http = new CommonHttp()

        return http
            .get(`persons/getInfo/${personId}`)
            .then(data => data.data)
    }

    // Вызов номера в приложении
    static callPhone(phoneNumber: string) {
        const http = new CommonHttp()

        return http
            .post(`persons/search/phone/call?phone=${phoneNumber}`, null)
            .then(data => data.data)
    }

    // Получает список возможных для присоединения к контакту клиентов
    static getAttachClientsList(Id: number, Filter: string, Skip: number, Take: number): Promise<AddedClient[]> {
        const http = new CommonHttp()

        return http
            .get(`persons/attach/list?Id=${Id}&Filter=${Filter}&Skip=${Skip}&Take=${Take}`)
            .then(data => data.data)
    }

    // Присоединяет выбранного клиента к контакту
    static attachClient(contactId: number, clientId: number): Promise<CommonEntityRecord[]> {
        const http = new CommonHttp()

        return http
            .put(`persons/attach`, {
                entityIdToAttach: contactId,
                clientId
            })
            .then(data => data.data)
    }

    // Отсоединяет выбранного клиента от контакта
    static detachClient(contactId: number, clientId: number): Promise<CommonEntityRecord[]> {
        const http = new CommonHttp()

        return http
            .put(`persons/detach`, {
                entityIdToAttach: contactId,
                clientId
            })
            .then(data => data.data)
    }

    // Отсоединяет выбранного клиента от контакта (возвращает Promise)
    static detachClientPromise(contactId: number, clientId: number): Promise<any> {
        const http = new CommonHttp()

        return http.put(`persons/detach`, {
                entityIdToAttach: contactId,
                clientId
        })
    }

    // Проверка контакта на существование
    static checkContactIsExist(contactText: string): Promise<Client[]> {
        const http = new CommonHttp()

        return http
            .get(`persons/search?contactInfo=${contactText}`)
            .then(data => data.data)
    }

    // Пполучение одиночного контакта
    static getSingleContact(contactId: number): Promise<any> {
        const http = new CommonHttp()
        return http.get(`persons/${contactId}`)
    }

    // Получение нескольких контактов по id (загрузка найденных дублей)
    static async getContactsByIds(contactIds: number[]): Promise<Client[]> {
        const settled = await Promise.allSettled(contactIds.map(id => PersonApi.getSingleContact(id)))

        return settled
            .filter((result): result is PromiseFulfilledResult<any> => result.status === 'fulfilled')
            .map(result => result.value.data)
    }
}

type AddedClient = {
    Id: number;
    Name: string;
    Address: string[]
}
